/* ==========================================================================
   NasoStrips SPORT — relojes, cambio de estado, lista y compra
   ------------------------------------------------------------------------
   Cada pieza de la campaña es un [data-nss-root] (la página, la ficha, la
   franja superior, el bloque de la portada, la tarjeta del catálogo). Todas
   llevan escritos en el HTML sus estados posibles con [data-nss="pre|live|
   opening"], y aquí solo se decide cuál se enseña. Si este archivo no llega
   a ejecutarse, el visitante ve el estado que ya pintó Liquid: nunca una
   pantalla vacía.

   Reglas que vienen de golpes anteriores en este tema:
   - No guardar referencias al DOM entre pasadas: el editor repinta secciones.
   - Nada depende de IntersectionObserver (hay navegadores integrados donde
     no dispara): la barra fija usa el scroll de toda la vida.
   - La hora buena es la de Shopify, no la del móvil del cliente: se corrige
     con la cabecera Date de una petición al servidor.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__nssInit) return;
  window.__nssInit = true;

  /* ---------- utilidades ---------- */
  var LS = {
    get: function (k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} },
    del: function (k) { try { window.localStorage.removeItem(k); } catch (e) {} }
  };
  var SS = {
    get: function (k) { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { window.sessionStorage.setItem(k, v); } catch (e) {} },
    del: function (k) { try { window.sessionStorage.removeItem(k); } catch (e) {} }
  };
  function pad(n) { return n < 10 ? '0' + n : String(n); }
  /* «16,00 €»: cifra, espacio y símbolo, como la ficha y el catálogo. */
  function money(c) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; }
  function $all(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function roots() { return $all(document, '[data-nss-root]'); }
  function num(el, k, d) { var v = parseInt(el.getAttribute(k), 10); return isNaN(v) ? d : v; }

  /* ---------- hora del servidor ---------- */
  var offset = 0;
  function now() { return Date.now() + offset; }
  function syncClock() {
    if (!window.fetch) return;
    var t0 = Date.now();
    fetch('/cart.js', { method: 'HEAD', cache: 'no-store', credentials: 'same-origin' })
      .then(function (r) {
        var d = Date.parse(r.headers.get('Date') || '');
        if (isNaN(d)) return;
        var mid = t0 + (Date.now() - t0) / 2;
        var off = d - mid;
        /* La cabecera va en segundos enteros: solo corregimos desfases reales. */
        if (Math.abs(off) > 1500) { offset = off; tick(); }
      })
      .catch(function () {});
  }

  /* ---------- quién es el visitante ---------- */
  function markJoined() {
    LS.set('nss-joined', '1');
    document.documentElement.classList.add('nss-joined');
  }
  /* La página NO lleva el código a la vista (cualquiera lo leería en el
     código fuente y «solo para la lista» dejaría de ser verdad): lleva su
     huella SHA-256, y aquí se compara con la huella del código que trae el
     visitante en su cookie o en su carrito. */
  function listHash(root) { return String(root.getAttribute('data-code-hash') || '').toLowerCase(); }
  function sha256(text) {
    if (!window.crypto || !crypto.subtle || !window.TextEncoder) return Promise.resolve('');
    return crypto.subtle.digest('SHA-256', new TextEncoder().encode(text)).then(function (buf) {
      return Array.prototype.map.call(new Uint8Array(buf), function (b) { return ('0' + b.toString(16)).slice(-2); }).join('');
    }).catch(function () { return ''; });
  }
  function cookieCode() {
    var m = document.cookie.match(/(?:^|;\s*)discount_code=([^;]*)/);
    return m ? decodeURIComponent(m[1]).toUpperCase() : '';
  }

  /* ---------- estados ---------- */
  function setView(root, view) {
    if (root.getAttribute('data-nss-view') === view) return false;
    root.setAttribute('data-nss-view', view);
    $all(root, '[data-nss]').forEach(function (n) {
      if (n.closest('[data-nss-root]') !== root) return;
      n.hidden = (' ' + n.getAttribute('data-nss') + ' ').indexOf(' ' + view + ' ') === -1;
    });
    return true;
  }

  function paintClock(root, ms) {
    var total = Math.max(0, Math.floor(ms / 1000));
    var v = {
      d: Math.floor(total / 86400),
      h: Math.floor((total % 86400) / 3600),
      m: Math.floor((total % 3600) / 60),
      s: total % 60
    };
    ['d', 'h', 'm', 's'].forEach(function (k) {
      $all(root, '[data-clock="' + k + '"]').forEach(function (n) {
        var t = pad(v[k]);
        if (n.textContent === t) return;
        n.textContent = t;
        if (n.classList.contains('nss-tickable')) {
          n.classList.remove('is-tick'); void n.offsetWidth; n.classList.add('is-tick');
        }
      });
    });
    $all(root, '[data-clock-label]').forEach(function (n) {
      var t = v.d + ' días, ' + v.h + ' horas y ' + v.m + ' minutos';
      if (n.textContent !== t) n.textContent = t;
    });
  }

  /* Al dar la hora: la página y la ficha necesitan que Shopify pinte el
     botón de compra y el stock de verdad. Si lo que tenemos delante se
     pintó antes de la hora (o Shopify aún no ha publicado el producto),
     se enseña «abriendo la venta» y se vuelve a pedir la página, con
     esperas crecientes y un máximo. Nunca un bucle de recargas. */
  var RETRY = [1500, 4000, 8000, 15000, 25000, 40000];
  var retryArmed = false;
  var demoNoRetry = false;
  function openSale(root) {
    var readyOnServer = root.getAttribute('data-server-state') === 'live' && root.getAttribute('data-has-product') === '1';
    if (readyOnServer) {
      setView(root, 'live');
      SS.del('nss-retry');
      if (/[?&]nss=/.test(location.search) && window.history && history.replaceState) {
        var u = new URL(location.href); u.searchParams.delete('nss');
        history.replaceState(null, '', u.pathname + u.search + u.hash);
      }
      return;
    }
    setView(root, 'opening');
    if (retryArmed) return;
    retryArmed = true;
    var n = parseInt(SS.get('nss-retry') || '0', 10) || 0;
    if (demoNoRetry || n >= RETRY.length) {
      $all(root, '[data-nss-giveup]').forEach(function (g) { g.hidden = false; });
      return;
    }
    SS.set('nss-retry', String(n + 1));
    setTimeout(function () {
      var u = new URL(location.href); u.searchParams.set('nss', String(Date.now()));
      location.replace(u.toString());
    }, RETRY[n]);
  }

  function offerOpen(root) {
    var end = Date.parse(root.getAttribute('data-end') || '');
    return isNaN(end) ? true : now() < end;
  }

  function tick() {
    var t = now();
    roots().forEach(function (root) {
      var launch = Date.parse(root.getAttribute('data-launch') || '');
      var kind = root.getAttribute('data-kind');
      var serverLive = root.getAttribute('data-server-state') === 'live';

      /* Si Shopify ya dice que está a la venta, manda Shopify (aunque el
         reloj del móvil vaya atrasado). */
      if (serverLive && (kind !== 'page' || root.getAttribute('data-has-product') === '1')) {
        setView(root, 'live');
      } else if (isNaN(launch) || t < launch) {
        setView(root, 'pre');
        if (!isNaN(launch)) paintClock(root, launch - t);
      } else if (kind === 'page') {
        openSale(root);
      } else {
        setView(root, 'live');
      }

      /* Ventana de la oferta de la lista (tras el lanzamiento). */
      var open = offerOpen(root);
      root.classList.toggle('offer-open', open);
      if (!open && root.classList.contains('has-code')) { root.classList.remove('has-code'); paintTicket(root); }
      var end = Date.parse(root.getAttribute('data-end') || '');
      if (open && !isNaN(end)) {
        $all(root, '[data-offer-clock]').forEach(function (n) {
          var s = Math.max(0, Math.floor((end - t) / 1000));
          var d = Math.floor(s / 86400), h = Math.floor((s % 86400) / 3600), m = Math.floor((s % 3600) / 60);
          var txt = (d ? d + ' d ' : '') + h + ' h ' + pad(m) + ' min';
          if (n.textContent !== txt) n.textContent = txt;
        });
      }
    });
  }

  /* ---------- existencias reales ---------- */
  function paintStock(root) {
    var left = num(root, 'data-stock', NaN), total = num(root, 'data-units', NaN);
    if (isNaN(left) || isNaN(total) || total <= 0) return;
    var sold = Math.max(0, total - left);
    var pct = Math.min(100, Math.max(0, (sold / total) * 100));
    $all(root, '[data-stock-bar]').forEach(function (n) { n.style.width = pct.toFixed(1) + '%'; });
    $all(root, '[data-stock-left]').forEach(function (n) { if (n.textContent !== String(left)) n.textContent = String(left); });
    $all(root, '[data-stock-sold]').forEach(function (n) { if (n.textContent !== String(sold)) n.textContent = String(sold); });
  }

  /* ---------- vista previa (SOLO en temas sin publicar) ----------
     ?nss_demo=live      cómo se verá desde el 1 de octubre a las 10:00
     ?nss_demo=code      lo mismo, entrando desde el enlace del correo de la lista
     ?nss_demo=joined    antes del lanzamiento, alguien que ya se apuntó
     ?nss_demo=opening   el minuto justo en que Shopify publica el producto
     Liquid solo pone data-demo-allowed cuando el tema NO es el publicado, así
     que en la web real estos parámetros no hacen nada. */
  var DEMO = (function () {
    try { return (new URLSearchParams(location.search).get('nss_demo') || '').toLowerCase(); } catch (e) { return ''; }
  })();
  function applyDemo() {
    if (!DEMO) return;
    roots().forEach(function (root) {
      if (root.getAttribute('data-demo-allowed') !== '1') return;
      if (DEMO === 'joined') { document.documentElement.classList.add('nss-joined'); return; }
      if (DEMO === 'live' || DEMO === 'code') {
        root.setAttribute('data-server-state', 'live');
        root.setAttribute('data-has-product', '1');
        root.setAttribute('data-stock', '734');
        root.setAttribute('data-launch', new Date(Date.now() - 3600000).toISOString());
        if (DEMO === 'code') root.classList.add('has-code');
        $all(root, 'form[data-nss-buy]').forEach(function (f) {
          f.addEventListener('submit', function (e) { e.preventDefault(); alert('Vista previa: el 1 de octubre este botón añade SPORT al carrito.'); });
        });
      }
      if (DEMO === 'opening') {
        root.setAttribute('data-server-state', 'pre');
        root.setAttribute('data-has-product', '0');
        root.setAttribute('data-launch', new Date(Date.now() - 1000).toISOString());
        demoNoRetry = true;
      }
    });
  }

  /* ---------- compra: cantidad, ticket y código de la lista ---------- */
  function paintTicket(root) {
    var form = root.querySelector('[data-nss-buy]');
    if (!form) return;
    var qtyEl = form.querySelector('input[name="quantity"]');
    var max = num(qtyEl, 'max', 10);
    var q = parseInt(qtyEl.value, 10);
    if (isNaN(q) || q < 1) q = 1;
    if (q > max) q = max;
    if (String(q) !== qtyEl.value) qtyEl.value = q;

    var price = num(root, 'data-price', 0);
    var cut = num(root, 'data-cut', 0);
    /* Comprobado con Shopify: el descuento se trunca POR BOLSA
       (2 bolsas = 2 × 3,99 €), no sobre el total. */
    var withCode = root.classList.contains('has-code') && root.classList.contains('offer-open');
    var line = price * q;
    var save = withCode ? cut * q : 0;
    var total = line - save;

    function set(sel, txt) { $all(root, sel).forEach(function (n) { if (n.textContent !== txt) n.textContent = txt; }); }
    set('[data-t="qty"]', String(q));
    set('[data-t="line"]', money(line));
    set('[data-t="save"]', '−' + money(save));
    set('[data-t="total"]', money(total));
    set('[data-t="btn"]', money(total));
    set('[data-t="bags"]', q === 1 ? '1 bolsa' : q + ' bolsas');

    var gift = form.querySelector('[data-nss-gift]');
    if (gift) gift.disabled = !withCode;
  }

  function detectCode(root) {
    var want = listHash(root);
    if (!want) return;
    /* Solo mientras dure la oferta: después, ni caja «precio de lista» ni regalo. */
    function on() {
      if (root.classList.contains('has-code') || !offerOpen(root)) return;
      root.classList.add('has-code');
      paintTicket(root);
    }
    function check(code) {
      if (!code) return;
      sha256(String(code).toUpperCase()).then(function (h) { if (h && h === want) on(); });
    }
    check(cookieCode());
    if (!window.fetch) return;
    fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart || !cart.discount_codes) return;
        cart.discount_codes.forEach(function (d) { check(d.code); });
      })
      .catch(function () {});
  }

  function bindBuy(root) {
    var form = root.querySelector('[data-nss-buy]');
    if (!form || form.__nss) return;
    form.__nss = true;
    var qtyEl = form.querySelector('input[name="quantity"]');
    $all(form, '[data-nss-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        var step = parseInt(b.getAttribute('data-nss-step'), 10) || 0;
        qtyEl.value = (parseInt(qtyEl.value, 10) || 1) + step;
        paintTicket(root);
      });
    });
    qtyEl.addEventListener('input', function () { paintTicket(root); });
    qtyEl.addEventListener('change', function () { paintTicket(root); });
    form.addEventListener('submit', function () {
      var btn = form.querySelector('button[type="submit"]');
      if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    });
    paintTicket(root);
  }

  /* ---------- lista: formularios, confirmación y compartir ---------- */
  function bindForms(root) {
    $all(root, 'form[data-nss-list]').forEach(function (f) {
      if (f.__nss) return;
      f.__nss = true;
      f.addEventListener('submit', function () {
        var btn = f.querySelector('button[type="submit"]');
        if (btn) { btn.disabled = true; btn.textContent = 'Apuntando…'; }
      });
    });
    $all(root, '[data-nss-again]').forEach(function (b) {
      if (b.__nss) return;
      b.__nss = true;
      b.addEventListener('click', function () {
        document.documentElement.classList.remove('nss-joined');
        var input = root.querySelector('form[data-nss-list] input[type="email"]');
        if (input) { input.value = ''; input.focus(); }
      });
    });
    $all(root, '[data-nss-copy]').forEach(function (b) {
      if (b.__nss) return;
      b.__nss = true;
      b.addEventListener('click', function () {
        var url = b.getAttribute('data-nss-copy');
        var done = function () { var t = b.textContent; b.textContent = '¡Enlace copiado!'; setTimeout(function () { b.textContent = t; }, 1800); };
        if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(done, function () {});
        else { window.prompt('Copia este enlace:', url); }
      });
    });
    $all(root, '[data-nss-native]').forEach(function (b) {
      if (!navigator.share) return;
      b.hidden = false;
      if (b.__nss) return;
      b.__nss = true;
      b.addEventListener('click', function () {
        navigator.share({ title: b.getAttribute('data-title'), text: b.getAttribute('data-text'), url: b.getAttribute('data-url') }).catch(function () {});
      });
    });
  }

  /* Shopify vuelve de /contact con ?customer_posted=true. Solo cuenta como
     «apuntado» si en ESTA página hay un formulario de la lista SPORT. */
  function afterPost() {
    if (location.search.indexOf('customer_posted=true') === -1) return;
    var sportForm = document.querySelector('form[data-nss-list]');
    if (!sportForm) return;
    if (document.querySelector('[data-nss-error]')) return;
    markJoined();
    var box = document.querySelector('#ns-sport .nss-joined');
    if (box) {
      box.setAttribute('tabindex', '-1');
      try { box.scrollIntoView({ block: 'center' }); box.focus({ preventScroll: true }); } catch (e) {}
    }
    if (window.history && history.replaceState) {
      var u = new URL(location.href); u.searchParams.delete('customer_posted');
      history.replaceState(null, '', u.pathname + u.search);
    }
  }

  /* ---------- galería ---------- */
  function bindGallery(root) {
    var g = root.querySelector('[data-nss-gallery]');
    if (!g || g.__nss) return;
    g.__nss = true;
    var track = g.querySelector('.nss-slides');
    var thumbs = $all(g, '[data-nss-slide]');
    function current() {
      var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      thumbs.forEach(function (t, j) { t.setAttribute('aria-current', String(i === j)); });
    }
    thumbs.forEach(function (t, j) {
      t.addEventListener('click', function () {
        track.scrollTo({ left: j * track.clientWidth, behavior: 'smooth' });
        thumbs.forEach(function (x, k) { x.setAttribute('aria-current', String(k === j)); });
      });
    });
    var raf = 0;
    track.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(current); }, { passive: true });
  }

  /* ---------- barra fija: solo cuando el bloque de compra ya no se ve ---------- */
  function sticky() {
    var page = document.getElementById('ns-sport');
    if (!page) return;
    var offer = page.querySelector('[data-nss-offer]');
    var end = page.querySelector('[data-nss-end]');
    var bars = $all(page, '.nss-sticky');
    if (!offer || !bars.length) return;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var passed = offer.getBoundingClientRect().bottom < 0;
    var atEnd = end ? end.getBoundingClientRect().top < vh - 40 : false;
    var show = passed && !atEnd;
    bars.forEach(function (b) { b.classList.toggle('is-shown', show); });
  }

  /* ---------- franja superior: cerrar ---------- */
  function bindBar() {
    $all(document, '.nss-bar').forEach(function (bar) {
      var x = bar.querySelector('.nss-bar-x');
      if (!x || x.__nss) return;
      x.__nss = true;
      x.addEventListener('click', function () {
        LS.set('nss-bar-off', bar.getAttribute('data-nss-view') || 'pre');
        bar.remove();
      });
    });
  }

  /* ---------- arranque ---------- */
  function boot() {
    applyDemo();
    afterPost();
    roots().forEach(function (root) {
      paintStock(root);
      if (root.getAttribute('data-kind') === 'page') {
        bindGallery(root);
        bindForms(root);
        bindBuy(root);
        detectCode(root);
      }
    });
    bindBar();
    tick();
    sticky();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  syncClock();
  setInterval(tick, 1000);
  var sraf = 0;
  window.addEventListener('scroll', function () { cancelAnimationFrame(sraf); sraf = requestAnimationFrame(sticky); }, { passive: true });
  window.addEventListener('resize', sticky);
  document.addEventListener('shopify:section:load', boot);
  window.NSSport = { tick: tick, sticky: sticky, markJoined: markJoined };
})();
